import Figure from "~/components/figure"
import RenderCofabComponent from "~/renderCofabComponent"

export default class AngleFeatureVis extends Component {
  render() {
    const totals = {
      residual: 1177,
      regular: 1799,
      angles: 266,
      curves: 360,
    }

    const Neuron = ({ image, subtitle, activation, showPercentage = true }) => {
      return (
        <Surface marginX={20}>
          <Surface flexFlow="row" justifyContent="space-between">
            <Text size={500} fontWeight={600} marginLeft={3} marginBottom={5}>
              {subtitle}
            </Text>
            {showPercentage && (
              <Text>
                {Math.round((activation / totals.regular) * 100)}% Activation
              </Text>
            )}
          </Surface>
          <ZoomedImg src={image} size={200} padding={40} />
        </Surface>
      )
    }

    const Row = ({ neuron, decomposed, text }) => (
      <Surface flexFlow="row" justifyContent="space-between" marginY={20}>
        {text}
        {neuron}
        {decomposed}
        <Neuron
          image={require("./unedited.png")}
          subtitle="Unedited Neuron"
          showPercentage={false}
        />
      </Surface>
    )

    return (
      <Figure>
        <Surface alignItems="center">
          <Row
            decomposed={
              <img
                src={require("./curves-decomposed.png")}
                style={{ borderRadius: 5 }}
              />
            }
            neuron={
              <Neuron
                image={require("./curves.png")}
                subtitle="Only Curves"
                activation={totals.curves}
              />
            }
            text={
              <Text alignSelf="center" size={600} width={470} marginRight={20}>
                Using <b>only curves</b> we see a proper curve, no texture, and
                faint perpendicular lines. 20% of the activation is recovered.
              </Text>
            }
          />
          <Row
            decomposed={
              <img
                src={require("./angles-decomposed.png")}
                style={{ borderRadius: 5 }}
              />
            }
            neuron={
              <Neuron
                image={require("./angles.png")}
                subtitle="Only Angles"
                activation={totals.angles}
              />
            }
            text={
              <Text alignSelf="center" size={600} width={470} marginRight={20}>
                Using <b>only angles</b> we see a distored curve, no texture,
                and strong perpendicular lines. 15% of the activation is
                recovered.
              </Text>
            }
          />
          <Row
            decomposed={
              <img
                src={require("./residual-decomposed.png")}
                style={{ borderRadius: 5 }}
              />
            }
            neuron={
              <Neuron
                image={require("./residual.png")}
                subtitle="Residual"
                activation={totals.residual}
              />
            }
            text={
              <Text alignSelf="center" size={600} width={470} marginRight={20}>
                By using <b>only other neurons</b> it still renders a textured
                curve, but it is off in subtle ways. 65% of the activation is
                recovered.
              </Text>
            }
          />
        </Surface>
      </Figure>
    )
  }
}
